import React, { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { useParams } from "react-router-dom";
import {
  //   DownloadPDFGhatIssueDetails,
  getGhatById,
} from "./services/ghat.services";
import { clearGhatDetail } from "./ghatSlice";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Button } from "@progress/kendo-react-buttons";
import { Typography } from "@progress/kendo-react-common";
import {
  checkAcessRights,
  formatToIndianCurrency,
  formatToIndianCurrencyWithoutSymbol,
  formatWeight,
} from "../../_helper/helper";
import { PRINT_ACCESS } from "../../_contstants/common";
import { IoMdPrint } from "react-icons/io";
import moment from "moment";
import { LoadingPanel } from "../../components/layout/Loading";
// import { MdOutlineFileDownload } from "react-icons/md";
// import { API_URL } from "../../app/config";
// import { ErrorToast } from "../../components/toast/Toasts";
import { Checkbox } from "@progress/kendo-react-inputs";

const GhatIssueVoucherPDF = () => {
  const dispatch = useAppDispatch();
  const param = useParams();
  const ghat_guid = param?.ghat_guid || "";
  const GhatDetail = useAppSelector((state) => state.ghat.GhatDetail);
  const loading = useAppSelector((state) => state.ghat.loading);
  const karigarIdWiseOutStandingAmount =
    GhatDetail?.karigarIdWiseOutStandingAmount &&
    GhatDetail?.karigarIdWiseOutStandingAmount?.length > 0
      ? GhatDetail?.karigarIdWiseOutStandingAmount[0]
      : {};

  const size_detail = (order_id: any) => {
    return GhatDetail?.SizeDetails && GhatDetail?.SizeDetails?.length > 0
      ? GhatDetail?.SizeDetails?.filter(
          (size: any) => size.order_id === order_id,
        )
      : [];
  };

  // console.log(karigarIdWiseOutStandingAmount);
  const isPrintAccess = checkAcessRights("/ghatissue", PRINT_ACCESS);
  const gridRef = useRef<any>(null);
  const [withImage, setWithImage] = useState(false);

  const handleWithImage = () => {
    setWithImage((pre) => !pre);
  };

  useEffect(() => {
    return () => {
      dispatch(clearGhatDetail());
    };
  }, []);

  useEffect(() => {
    if (ghat_guid) {
      dispatch(getGhatById(ghat_guid));
    }
  }, [ghat_guid]);

  useEffect(() => {
    const style = document.createElement("style");
    style.type = "text/css";
    style.innerHTML = `
      @media print {
        @page {
          margin-left: 0.5cm;
          margin-right: 0.5cm;
        }
        .no-print {
          display: none !important;
        }
        .issue-order-item-print-break {
          page-break-inside: avoid;
        }
        .container {
          width: 100% !important;
          max-width: 100% !important;
          padding: 0 !important;
          margin: 0 !important;
        }
        body {
          zoom: 70% !important;
        }
        .table-bordered, .table-bordered td, .table-bordered th {
          border: 1px solid #c2c2c2ff !important;
        }
      }
    `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  const handlePrint = () => {
    window.print();
  };

/*
  const handleDownloadPdf = async (ghat_guid: string, issue_no: any) => {
    try {
      const response = await fetch(`${API_URL}/Ghat/FIndByIDGhatDownloadPDf`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ghat_guid,
          isimageview: withImage,
        }),
      });

      if (!response.ok) {
        ErrorToast("Failed to generate PDF! - Please try after some time");
        throw new Error(`Error: ${response.status} - ${response.statusText}`);
      }
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `Ghat-Issue-${issue_no || moment().date()}.pdf`;
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
      ErrorToast("Failed to download PDF! - Please try again later");
    }
  };
*/

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}

      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem>
          <div
            className="printbuttons no-print"
            style={{
              textAlign: "center",
              padding: "20px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {isPrintAccess && (
              <>
                <div
                  style={{
                    marginRight: "10px",
                    padding: "3px 10px",
                    border: "none",
                  }}
                >
                  <Checkbox
                    label="With Image "
                    size="large"
                    labelPlacement="before"
                    onChange={handleWithImage}
                    checked={withImage}
                  />
                </div>
                <Button
                  type="button"
                  style={{
                    marginRight: "10px",
                    padding: "5px 10px",
                    border: "none",
                  }}
                  fillMode={"solid"}
                  themeColor={"primary"}
                  onClick={handlePrint}
                >
                  <IoMdPrint style={{ fontSize: "20px" }} /> Print Report
                </Button>
              </>
            )}
            {/* {isPrintAccess && (
              <Button
                type="button"
                style={{
                  marginRight: "10px",
                  padding: "5px 10px",
                  border: "none",
                }}
                fillMode={"solid"}
                themeColor={"tertiary"}
                onClick={() =>
                  handleDownloadPdf(ghat_guid, GhatDetail.issue_no)
                }
              >
                <MdOutlineFileDownload style={{ fontSize: "20px" }} /> Download
              </Button>
            )} */}
          </div>
        </GridLayoutItem>
        <GridLayoutItem>
          <Typography.h5
            style={{
              marginBottom: 0,
              textAlign: "center",
            }}
          >
            GHAT ISSUE VOUCHER
          </Typography.h5>
          <Typography.h6
            style={{
              marginBottom: 15,
              textAlign: "center",
            }}
          >
            ISSUE NO : {GhatDetail?.issue_no} | ISSUE DATE :{" "}
            {moment(GhatDetail?.issue_date).format("DD/MM/YYYY")}
          </Typography.h6>
        </GridLayoutItem>
      </GridLayout>

      <div className="container">
        <div
          style={{
            display: "flex",
            justifyContent: "end",
            flexDirection: "column",
            marginBottom: 10,
          }}
        >
          <div className="card-header bg-light">
            <h5 className="mb-0 fw-bold">Karigar Stock</h5>
          </div>
          <div className="stock-container">
            <div className="stock-item w-100">
              <div className="stock-header">
                <div
                  className={`indicator-dot amount-dot-${karigarIdWiseOutStandingAmount.Amount_credit_debit}`}
                ></div>
                <Typography.h6 className="stock-label">
                  Amount Balance
                </Typography.h6>
              </div>
              <Typography.h6
                className={`stock-value text-nowrap amount-value-${karigarIdWiseOutStandingAmount.Amount_credit_debit}`}
              >
                ₹
                {formatToIndianCurrencyWithoutSymbol(
                  karigarIdWiseOutStandingAmount.amount || 0,
                )}{" "}
                <span
                  style={{
                    fontWeight: "normal",
                    textTransform: "capitalize",
                    fontSize: 16,
                  }}
                >
                  {karigarIdWiseOutStandingAmount.Amount_credit_debit}
                </span>
              </Typography.h6>
            </div>

            <div className="stock-item  w-100">
              <div className="stock-header">
                <div
                  className={`indicator-dot phine-dot-${karigarIdWiseOutStandingAmount.phine_credit_debit}`}
                ></div>
                <Typography.h6 className="stock-label">
                  Phine (gm) Stock
                </Typography.h6>
              </div>
              <Typography.h6
                className={`stock-value phine-value-${karigarIdWiseOutStandingAmount.phine_credit_debit}`}
              >
                {formatWeight(karigarIdWiseOutStandingAmount.phine)}{" "}
                <span
                  style={{
                    fontWeight: "normal",
                    textTransform: "capitalize",
                    fontSize: 16,
                  }}
                >
                  {karigarIdWiseOutStandingAmount.phine_credit_debit}
                </span>
              </Typography.h6>
            </div>
          </div>
        </div>
        {/* Summary Information */}
        <div className="card summary-card mb-3">
          <div className="card-header bg-light">
            <h5 className="mb-0 fw-bold">Order Summary</h5>
          </div>
          <div className=" p-0">
            <table className="table table-bordered mb-0">
              <tbody>
                <tr>
                  <td style={{ width: "20%" }}>
                    <strong>Karigar</strong>
                    <br />
                    <span>{GhatDetail?.karigar_name}</span>
                  </td>
                  <td style={{ width: "20%" }}>
                    <strong>Address</strong>
                    <br />
                    <span>{GhatDetail?.address}</span>
                  </td>
                  <td style={{ width: "20%" }}>
                    <strong>Given Amount</strong>
                    <br />
                    <span className="text-success">
                      {formatToIndianCurrency(GhatDetail?.given_amount || 0)}
                    </span>
                  </td>
                  <td style={{ width: "40%" }}>
                    <strong>Remarks</strong>
                    <br />
                    <span className="text-muted">{GhatDetail?.remarks}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        {/* Gold Issues */}
        {GhatDetail?.ghat_gold_issues?.length > 0 && (
          <div className="card gold-card mb-3">
            <div className="card-header bg-light">
              <h5 className="mb-0 fw-bold">Gold Issued to Karigar</h5>
            </div>
            <div className="card-body p-0">
              <div className="table-responsive">
                <table className="table table-bordered mb-0">
                  <thead className="table-warning">
                    <tr>
                      <th>Item</th>
                      <th>Given Weight (gm)</th>
                      <th>Purity</th>
                      <th>Wastage</th>
                      <th>Phine (gm)</th>
                      <th>Pieces</th>
                    </tr>
                  </thead>
                  <tbody>
                    {GhatDetail?.ghat_gold_issues?.map((gold_issue, idx) => {
                      return (
                        <tr key={gold_issue?.id || idx}>
                          <td>{gold_issue?.item_name}</td>
                          <td>{formatWeight(gold_issue?.given_weight)}</td>
                          <td>{gold_issue?.given_purity}</td>
                          <td>{gold_issue?.given_wastage}</td>
                          <td>{formatWeight(gold_issue?.phine)}</td>
                          <td>{gold_issue?.pcs}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
        {/* Ghat Items */}
        <h5 className="m-2 mt-3 fw-bold">Order Details</h5>
        {GhatDetail?.ghat_item?.map((item, index) => {
          return (
            <div
              key={item?.id || index}
              className={`card items-card issue-order-item-print-break ${
                index ? "mt-4" : ""
              }`}
            >
              <div
                className="card-header"
                style={{ backgroundColor: "lightsteelblue" }}
              >
                <h5 className="mb-0">Order No : {item?.order_no}</h5>
              </div>
              <div className="card-body p-0">
                <div className="p-1">
                  <div className="card items-card">
                    <div className="card-header bg-light p-1">
                      <h6 className="mb-0 fw-bold">Item Details</h6>
                    </div>
                    <div className="card-body p-0">
                      <table className="table table-bordered mb-0">
                        <tbody>
                          <tr>
                            <td style={{ width: "25%", padding: "2px 5px" }}>
                              <p className="m-0">
                                <strong>Category</strong>
                              </p>
                              <p className="m-0">{item?.category_name}</p>
                            </td>
                            <td style={{ width: "25%", padding: "2px 5px" }}>
                              <p className="m-0">
                                <strong>Sub Category</strong>
                              </p>
                              <p className="m-0">
                                {item?.item_subcategory_name}
                              </p>
                            </td>
                            <td style={{ width: "25%", padding: "2px 5px" }}>
                              <p className="m-0">
                                <strong>Delivery Date</strong>
                              </p>
                              <p className="m-0">
                                {item?.approx_delivery_date
                                  ? moment(item?.approx_delivery_date).format(
                                      "DD/MM/YYYY",
                                    )
                                  : ""}
                              </p>
                            </td>
                            <td style={{ width: "25%", padding: "2px 5px" }}>
                              <p className="m-0">
                                <strong>Priority</strong>
                              </p>
                              <p className="m-0">{item?.priority}</p>
                            </td>
                          </tr>
                          <tr>
                            <td style={{ width: "25%", padding: "2px 5px" }}>
                              <p className="m-0">
                                <strong>Estimated Weight (gm)</strong>
                              </p>
                              <p className="m-0">
                                {formatWeight(item?.weight)}
                              </p>
                            </td>
                            <td style={{ width: "25%", padding: "2px 5px" }}>
                              <p className="m-0">
                                <strong>Purity</strong>
                              </p>
                              <p className="m-0">
                                {item?.Carat} {item?.purity}
                              </p>
                            </td>
                            <td style={{ width: "25%", padding: "2px 5px" }}>
                              <p className="m-0">
                                <strong>Size</strong>
                              </p>
                              <p className="m-0">{item?.size}</p>
                            </td>
                            <td style={{ width: "25%", padding: "2px 5px" }}>
                              <p className="m-0">
                                <strong>Color</strong>
                              </p>
                              <p className="m-0">{item?.color}</p>
                            </td>
                          </tr>
                          <tr>
                            <td
                              colSpan={4}
                              style={{ width: "33.33%", padding: "2px 5px" }}
                            >
                              <p className="m-0">
                                <strong>Remark</strong>
                              </p>
                              <p className="m-0">{item?.remarks}</p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {item?.approval_items?.length > 0 && (
                    <div className="card items-card mt-1">
                      <div className="card-header bg-light p-1">
                        <h6 className="mb-0 fw-bold">Approval Items</h6>
                      </div>
                      <div className="card-body p-0">
                        <div className="approval-table">
                          <table className="table table-bordered mb-0 approval-items-table">
                            <thead>
                              <tr>
                                <th style={{ width: "10%" }}>Type</th>
                                <th style={{ width: "25%" }}>Item</th>
                                <th style={{ width: "15%" }}>Weight (gm)</th>
                                <th style={{ width: "10%" }}>Qty</th>
                                <th style={{ width: "40%" }}>Remarks</th>
                              </tr>
                            </thead>
                            <tbody>
                              {item?.approval_items?.map(
                                (approval_item, idx) => {
                                  return (
                                    <tr key={approval_item?.id || idx}>
                                      <td>{approval_item?.type}</td>
                                      <td>{approval_item?.item_name}</td>
                                      <td>
                                        {formatWeight(approval_item?.weight)}
                                      </td>
                                      <td>{approval_item?.qty}</td>
                                      <td>{approval_item?.remarks}</td>
                                    </tr>
                                  );
                                },
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                {/* <div className="table-responsive"> */}
                {/* <table className="table table-bordered mb-0 issue-order-items-table">
                <tbody>
                  <tr>
                    <td>
                      <div className="card items-card">
                        <div className="card-header bg-light p-1">
                          <h6 className="mb-0">Item Details</h6>
                        </div>
                        <div className="card-body p-0">
                          <table className="table table-bordered mb-0">
                            <tbody>
                              <tr>
                                <td style={{ width: "25%" }}>
                                  <strong>Product</strong>
                                  <br />
                                  <span> Gold Chain 22 CT</span>
                                </td>
                                <td style={{ width: "25%" }}>
                                  <strong>Order No</strong>
                                  <br />
                                  <span>2</span>
                                </td>
                                <td style={{ width: "25%" }}>
                                  <strong>Size</strong>
                                  <br />
                                  <span>18</span>
                                </td>
                                <td style={{ width: "25%" }}>
                                  <strong>Weight</strong>
                                  <br />
                                  <span>26 gm</span>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <strong>Color</strong>
                                  <br />
                                  <span>Gold</span>
                                </td>
                                <td>
                                  <strong>Category</strong>
                                  <br />
                                  <span>Gold Chain</span>
                                </td>
                                <td>
                                  <strong>Purity</strong>
                                  <br />
                                  <span>22 CT</span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div className="card items-card">
                        <div className="card-header bg-light p-1">
                          <h6 className="mb-0">Approval Items</h6>
                        </div>
                        <div className="card-body p-0">
                          <div className="approval-table">
                            <table className="table table-bordered mb-0 approval-items-table">
                              <thead>
                                <tr>
                                  <th>Type</th>
                                  <th>Item</th>
                                  <th>Weight</th>
                                  <th>Qty</th>
                                  <th>Remarks</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>SAMPLE</td>
                                  <td>Sample Chain</td>
                                  <td>60 gm</td>
                                  <td>2</td>
                                  <td>
                                    2 sample given asdfasd asdfasa asdfasd
                                    asdfasd
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table> */}
                {/* <table className="table table-bordered mb-0 issue-order-items-table">
                <thead className="table-success">
                  <tr>
                    <th>Item Details</th>
                    <th>Specifications</th>
                    <th>Approval Items</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <h6
                        style={{
                          textTransform: "uppercase",
                          fontWeight: "bold",
                        }}
                      >
                        Gold Chain 22 CT
                      </h6>
                      <h6 className="text-muted">Order No : 2</h6>
                    </td>
                    <td>
                      <table className="table table-bordered specifications-table">
                        <tbody>
                          <tr>
                            <td>
                              <strong>Size</strong>
                            </td>
                            <td>18</td>
                          </tr>
                          <tr>
                            <td>
                              <strong>Weight</strong>
                            </td>
                            <td>26 gm</td>
                          </tr>
                          <tr>
                            <td>
                              <strong>Color</strong>
                            </td>
                            <td>Gold</td>
                          </tr>
                          <tr>
                            <td>
                              <strong>Category</strong>
                            </td>
                            <td>Gold Chain</td>
                          </tr>
                          <tr>
                            <td>
                              <strong>Purity</strong>
                            </td>
                            <td>22 CT</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                    <td>
                      <div className="approval-table">
                        <table className="table table-bordered mb-0 approval-items-table">
                          <thead>
                            <tr>
                              <th>Type</th>
                              <th>Item</th>
                              <th>Weight</th>
                              <th>Qty</th>
                              <th>Remarks</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>SAMPLE</td>
                              <td>Sample Chain</td>
                              <td>60 gm</td>
                              <td>2</td>
                              <td>2 sample given</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table> */}
                {/* </div> */}
              </div>
              <div className={`card p-2 shadow-sm border-0 mb-4`}>
                <div className="d-flex gap-4 justify-content-between">
                  <div
                    className={`position-relative rounded-3 ${
                      !withImage && `no-print`
                    }`}
                  >
                    <h5
                      className="mb-2"
                      style={{
                        color: "#2c3e50",
                        fontWeight: "600",
                        fontSize: "1.1rem",
                      }}
                    >
                      Process Image
                    </h5>
                    <div className="d-flex gap-2 flex-wrap">
                      {item?.ghatprocessimage?.map((img) => {
                        return (
                          <img
                            style={{
                              width: "150px",
                              cursor: "pointer",
                            }}
                            className="img-fluid object-fit-cover"
                            key={img?.id}
                            src={img?.image_name}
                            alt="Process Image"
                            onClick={() => window.open(img?.image_name)}
                          />
                        );
                      })}
                    </div>
                  </div>
                  <div className="position-relative rounded-3">
                    <h5
                      className="mb-2"
                      style={{
                        color: "#2c3e50",
                        fontWeight: "600",
                        fontSize: "1.1rem",
                      }}
                    >
                      Size Detail
                    </h5>
                    <div style={{ width: "450px" }}>
                      <table className="table table-bordered mb-0 approval-items-table">
                        <thead>
                          <tr>
                            <th>Title</th>
                            <th>Value</th>
                          </tr>
                        </thead>
                        <tbody>
                          {size_detail(item.order_id)?.map((size: any) => {
                            return (
                              <tr key={size.id}>
                                <td>{size?.title}</td>
                                <td>{size?.value}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default GhatIssueVoucherPDF;
